import { AdminSettingsTabType } from "../business-components/adminSettings/AdminSettingsTabType";
import { CvpSettings } from "../settings/CvpSettings";
import { CvpLocale } from "./CvpLocale";

export enum PostMessageTypes {
  CVPAdminPreviewRequestSettings = "CVPAdminPreviewRequestSettings",
  CVPAdminPreviewRequestSettingsResponse = "CVPAdminPreviewRequestSettingsResponse",
  CVPEmbedReadyForSettings = "CVPEmbedReadyForSettings",
  CVPEmbedConfig = "CVPEmbedConfig",
  CVPRedirectHost = "CVPRedirectHost",
  CVPIframeAvailableContentHeight = "CVPIframeAvailableContentHeight",
  CVPFocusTextId = "CVPFocusTextId",
}

export interface PostMessageCVPAdminPreviewRequestSettings {
  type: PostMessageTypes.CVPAdminPreviewRequestSettings;
  guid: string;
}

export interface PostMessageCVPAdminPreviewRequestSettingsResponse {
  type: PostMessageTypes.CVPAdminPreviewRequestSettingsResponse;
  guid: string;
  settingsComplete: CvpSettings;
}

export interface PostMessageCVPFocusTextId {
  type: PostMessageTypes.CVPFocusTextId;
  textId: string;
}

export interface PostMessageCVPRedirectHost {
  type: PostMessageTypes.CVPRedirectHost;
  url: string;
  method: "push" | "replace";
  scrollToY?: number;
  hardRedirect: boolean;
}

export interface PostMessageCVPEmbedReadyForSettings {
  type: PostMessageTypes.CVPEmbedReadyForSettings;
  loadId: string;
  cvpIsLoggedIn: boolean;
}

export interface PostMessageCVPEmbedConfig {
  type: PostMessageTypes.CVPEmbedConfig;
  settingsComplete: CvpSettings;
  iframe_overrideLocale?: CvpLocale;
  iframe_overrideTheme?: string;
  iframe_preventNavigationTakeover?: boolean;
  sandbox?: boolean;
  adminSettingsTabType?: AdminSettingsTabType;
  hostUrl?: string;
  iframeAvailableContentHeight?: number;
}
